import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "头版", href: "#headline" },
  { label: "现场", href: "#timeline" },
  { label: "追踪", href: "#deep" },
  { label: "热度", href: "#ranking" },
  { label: "板块", href: "#zones" },
  { label: "幕后", href: "#backstage" },
  { label: "评论区", href: "#comment" },
];

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header>
      {/* utility strip */}
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-2.5 md:px-6">
          <p className="flex items-center gap-2 text-xs tracking-wider text-background-100/90">
            <i className="ri-calendar-2-line text-accent-400 text-sm" aria-hidden="true"></i>
            <span className="whitespace-nowrap">2026 年 9 月 9 日 · 星期三</span>
            <span className="hidden border-l border-background-100/25 pl-3 text-background-100/70 sm:inline">
              第 4827 期 · 成人吃瓜圈子内幕日刊
            </span>
          </p>
          <div className="flex items-center gap-4 text-sm text-background-100">
            <span className="hidden items-center gap-1.5 whitespace-nowrap md:flex">
              <i className="ri-eye-line text-accent-400" aria-hidden="true"></i>
              今日围观 128.6w
            </span>
            <a href="#comment" className="flex items-center gap-1.5 whitespace-nowrap hover:text-accent-300">
              <i className="ri-user-3-line" aria-hidden="true"></i>
              <span className="hidden sm:inline">吃瓜群众</span>
            </a>
          </div>
        </div>
      </div>

      {/* masthead */}
      <div className="border-b border-foreground-200/60 bg-background-50">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 px-4 py-8 text-center md:px-6 md:py-10">
          <div className="flex items-center gap-3 text-xs font-medium tracking-[0.35em] text-primary-700">
            <span className="h-px w-10 bg-primary-500/40" />
            成人吃瓜 · CHI GUĀ MAGAZINE
            <span className="h-px w-10 bg-primary-500/40" />
          </div>
          <h1 className="font-heading text-4xl font-black tracking-[0.14em] text-foreground-950 md:text-6xl">
            成人吃瓜
          </h1>
          <p className="max-w-2xl font-heading text-sm leading-relaxed text-foreground-600 md:text-base">
            成人吃瓜圈子内幕 / 好友八卦 · 行业爆料 · 幕后闹剧 · 三观炸裂 · 饭圈谈资
          </p>
        </div>
      </div>

      {/* sticky nav */}
      <nav
        className={`sticky top-0 z-50 bg-background-50 transition-all ${
          scrolled ? "border-b border-foreground-200/60" : ""
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 md:px-6">
          <div className="hidden items-center gap-1 md:flex">
            {NAV_LINKS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2 md:hidden">
            <span className="font-heading text-lg font-bold tracking-widest text-foreground-950">
              成人吃瓜
            </span>
          </div>

          <div className="flex items-center gap-2">
            <label className="hidden items-center gap-2 rounded-full border border-foreground-300/60 bg-background-50 px-3.5 py-1.5 text-sm text-foreground-600 lg:flex">
              <i className="ri-search-line text-foreground-500" aria-hidden="true"></i>
              <input
                type="text"
                placeholder="搜圈子 / 人名 / 爆料关键词"
                className="w-40 bg-transparent text-sm outline-none placeholder:text-foreground-400"
              />
            </label>
            <a
              href="#zones"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 sm:flex"
            >
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
              进圈爆料
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-foreground-300/60 text-foreground-800 md:hidden"
              aria-label="菜单"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-foreground-200/60 bg-background-50 px-4 py-3 md:hidden">
            <div className="grid grid-cols-2 gap-1">
              {NAV_LINKS.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}